(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('home')) return;
    var el = document.getElementById('loader-logo');
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var innerImg = el.querySelector('.site-logo img, .site-logo svg, .logo-wrapper img, .logo-wrapper svg');
    if (!innerImg) return;

    function start() {
      // ensure intrinsic width (use full/original image for quality)
      var intrinsicW = innerImg.naturalWidth || innerImg.getBoundingClientRect().width || 150;
      var finalW = 150;
      var desktopStart = 300;
      var tabletStart = 240;
      var isTabletDown = window.matchMedia('(max-width: 1024px)').matches;
      var targetStartWidth = isTabletDown ? tabletStart : desktopStart;
      // scale factor (use width ratio, clamp with intrinsic if smaller)
      var startScale = targetStartWidth / finalW;
      // high-res source already loaded (ensure you used 'full' in PHP render)
      // Apply prep classes
      el.classList.add('logo-prep');
      el.classList.add('logo-start');
      el.style.setProperty('--logo-start-scale', startScale.toFixed(3));

      // force reflow
      void el.offsetWidth;

      // after delay enable transitions & go to final
      setTimeout(function () {
        el.classList.remove('logo-prep');
        // trigger animation to final
        el.classList.remove('logo-start');
        // let CSS drive final transforms (including optional final scale)
        innerImg.style.transform = '';
      }, 2000);
    }

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  });
})();